/**
 * header-scroll.js
 * Floating → sticky header behavior for the homepage.
 * Loaded only on request.page_type == 'index' via sections/header.liquid.
 *
 * Responsibilities:
 *  1. Set --bb-header-height so the hero can offset its negative margin-top.
 *  2. Toggle .header-is-sticky on .section-header when the user scrolls > threshold.
 */
(function () {
  var sectionHeader = document.querySelector('.section-header');
  if (!sectionHeader) return;

  var SCROLL_THRESHOLD = 10; // px — tiny buffer to avoid flicker at exact 0
  var ticking = false;

  // ── Height tracking ──────────────────────────────────────────────────────
  // Capture the floating-state header height (including the padding gap) and
  // expose it as a CSS variable consumed by section-header-floating.css.
  function updateHeaderHeight() {
    var h = sectionHeader.getBoundingClientRect().height;
    document.documentElement.style.setProperty('--bb-header-height', h + 'px');
  }

  // Run immediately (floating state, padding included → full height captured).
  updateHeaderHeight();

  // Re-measure on resize in case the logo or menu wraps.
  window.addEventListener('resize', function () {
    // Only re-measure in the at-rest (non-sticky) state so padding is included.
    if (!sectionHeader.classList.contains('header-is-sticky')) {
      updateHeaderHeight();
    }
  }, { passive: true });

  // ── Scroll handler ───────────────────────────────────────────────────────
  function applyScrollState() {
    var scrollY = window.scrollY || window.pageYOffset;

    if (scrollY > SCROLL_THRESHOLD) {
      sectionHeader.classList.add('header-is-sticky');
    } else {
      sectionHeader.classList.remove('header-is-sticky');
    }

    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(applyScrollState);
      ticking = true;
    }
  }, { passive: true });

  // Run once on load in case the page is refreshed mid-scroll.
  applyScrollState();
})();
